__webpack_require__.p = "/productregistration-static/";